import axios from "axios";
 
//需要配置打包
// axios.defailts.headers['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers["Content-Type"] = "application/json";
axios.defaults.headers["System-Type"] = "OFFICIAL";
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: "http://124.222.127.76:8901",
    // baseURL: "http://192.168.0.163:8901",
    // 超时
    timeout: 1000000, //10000
});
// 请求拦截
service.interceptors.request
    .use
    // config => {//请求成功时执行
    //     //获取本地存储中的token
    //     let token = localStorage.getItem('token');
    //     token && (config.headers.Authorization = token);
    //     return config;
    // },
    // error => {//请求失败时执行
    //     return Primise.reject(error)
    // }
    ();
 
service.interceptors.response.use(
    (response) => {
        return response.data;
    },
    (error) => {
        //拦截失败
        console.log(error);
        // return Primise.reject(error);
    }
);
export default service;